(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k9-header"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('.k9-menu').forEach(menu => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('km-menu-open', menu.open);
      menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.k9-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a,button')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.k9-menu[open]').forEach(menu => {menu.open = false;menu.querySelector('summary').focus();});
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.k9-menu[open]').forEach(menu => {if (!menu.contains(event.target)) menu.open = false;});
  });
  window.addEventListener('pageshow', () => document.querySelectorAll('.k9-menu[open]').forEach(menu => {menu.open = false;}));
  document.addEventListener('shopify:section:load', init);
  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
